import { useEffect, useMemo, useState } from 'react';
import { Button } from 'antd';

import CategorySelector from '../../../../../Common/SelectCategory';
import { filterQuestionsByUserType } from '../../../../Categories/[categoryId]/helpers';
import { useQuizStatuses } from '../../../../Categories/[categoryId]/useQuizStatuses';
import QuestionStatistic from '../../../../Categories/[categoryId]/QuestionStatistic';
import TakeSurvey from '../../../../Categories/[categoryId]/TakeSurvey';

import styles from './index.module.scss';
import { useSubCategoryById } from '../../../../Categories/[categoryId]/useSubCategoryById';
import { useCategoryById } from '../../../../Categories/[categoryId]/useCategoryById';
import { Left } from '../../../../../Common/Icon';

const SurveyStepOne = () => {
  const [step, setStep] = useState<1 | 2>(1); // current step
  const [selected, setSelected] = useState<{
    categoryId: string;
    subCategoryId: string;
  } | null>(null);

  const {
    getCategoryById,
    response: category,
    loading,
    error,
  } = useCategoryById();

  const { getSubCategoryById, response: subCategory } = useSubCategoryById();
  const { response: quizStatus, getQuizStatus } = useQuizStatuses();

  useEffect(() => {
    if (selected?.categoryId) {
      getCategoryById({ id: selected.categoryId });
    }
  }, [selected?.categoryId]);

  useEffect(() => {
    if (selected?.subCategoryId) {
      getSubCategoryById({ id: selected.subCategoryId });
      getQuizStatus(selected.subCategoryId);
    }
  }, [selected?.subCategoryId]);

  const handleNext = () => {
    if (selected?.categoryId && selected?.subCategoryId) {
      setStep(2); // move to next step
    } else {
      console.warn('Category or Sub-category not selected');
    }
  };

  const workersQuestions = useMemo(
    () => filterQuestionsByUserType(subCategory?.questions || [], 'worker'),
    [subCategory]
  );

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.innerWrapper}>
            {/* === Step 1: Select category === */}
            {step === 1 && (
              <>
                <div>
                  <h2>Tipping category</h2>
                  <p className={styles.description}>
                    Please select tipping category before starting survey
                  </p>
                </div>

                <CategorySelector onChange={setSelected} />

                <Button className={styles.buttonNext} onClick={handleNext}>
                  Next <Left style={{ transform: 'rotate(180deg)' }} />
                </Button>
              </>
            )}
          </div>
          {/* === SurveyStepOne: Show survey === */}
          {step === 2 && workersQuestions.length > 0 && (
            <div className={styles.surveyWrapper}>
              {quizStatus?.data.isCustomerQuizDone ? (
                <QuestionStatistic
                  questions={workersQuestions}
                  subCategoryId={selected?.subCategoryId || ''}
                  userType="customer"
                />
              ) : (
                <TakeSurvey
                  questions={workersQuestions}
                  onSuccess={() => getQuizStatus(selected?.subCategoryId || '')}
                  autoOpen
                  onExit={() => setStep(1)}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SurveyStepOne;
